import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const stackItems = [{
  name: 'Ebook principal: Volvé a Calmar tu Mente en 21 Días',
  value: 47
}, {
  name: 'Bono 1: Reprogramá tu Mente Ansiosa',
  value: 17
}, {
  name: 'Bono 2: Dormí en Paz',
  value: 17
}, {
  name: 'Bono 3: Ansiedad en Relaciones y Apego',
  value: 17
}, {
  name: 'Bono 4: Calmá tu Cuerpo',
  value: 12
}, {
  name: 'Bono 5: Detox de Estrés y Sobrecarga Mental',
  value: 12
}, {
  name: 'Bono 6: Sistema de Paz en 21 Días',
  value: 17
}];
export function ValueStackSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-navy text-beige-light relative overflow-hidden" data-id="element-183">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#C9A96E 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-184"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-185">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-186">
          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-white" data-id="element-187">
            Todo lo que recibís hoy
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-188"></div>
        </motion.div>

        <motion.div className="bg-navy-light/50 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-gold/20 shadow-2xl" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-189">
          <ul className="space-y-4 mb-10" data-id="element-190">
            {stackItems.map((item, index) => <motion.li key={index} className="flex items-center justify-between py-3 border-b border-white/10 last:border-0" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + index * 0.1
          }} data-id="element-191">
                <div className="flex items-center gap-3 pr-4" data-id="element-192">
                  <Check size={18} className="text-gold shrink-0" data-id="element-193" />
                  <span className={index === 0 ? 'font-medium text-white' : 'text-beige-light/80 text-sm md:text-base'} data-id="element-194">
                    {item.name}
                  </span>
                </div>
                <span className="text-gold/70 font-serif shrink-0" data-id="element-195">
                  Valor: ${item.value}
                </span>
              </motion.li>)}
          </ul>

          <div className="bg-navy-dark/50 rounded-2xl p-6 md:p-8 text-center border border-white/5" data-id="element-196">
            <p className="text-slate-light mb-2" data-id="element-197">
              Valor total:{' '}
              <span className="line-through" data-id="element-198">
                ${stackItems.reduce((acc, item) => acc + item.value, 0)} USD
              </span>
            </p>
            <h3 className="text-3xl md:text-4xl font-serif text-gold mb-8" data-id="element-199">
              Hoy accedés a todo por solo $27 USD
            </h3>

            <button onClick={scrollToCheckout} className="w-full sm:w-auto px-10 py-5 bg-gold text-navy-dark rounded-xl font-bold text-lg shadow-[0_0_30px_rgba(201,169,110,0.3)] hover:shadow-[0_0_40px_rgba(201,169,110,0.5)] hover:-translate-y-1 transition-all duration-300" data-id="element-200">
              QUIERO MI ACCESO AHORA
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}